module.exports = __webpack_public_path__ + "static/img/SC5.ec7444b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC5.jpg
// module id = x68D
// module chunks = 0